export default __webpack_public_path__ + "static/media/logo.8c1d1513.png";